<template>
  <img
    src="~/assets/icon/icon-close.svg"
    alt=""
  />
</template>
